<!--
 * @Author: qhy
 * @Date: 2023-07-01 15:29:37
 * @LastEditors: qhy
 * @LastEditTime: 2023-07-03 20:10:23
 * @Description: 分屏功能
-->
<template>
<div>
    <div class="fenping">
      <div id="map1" class="map"></div>
      <div id="map2" class="map"></div>
      <div id="map3" class="map"></div>
      <div id="map4" class="map"></div>
    </div>
    <div class="connectionBtn">
      <img @click="toggleConnection" title="联动已开启" v-if="isConnection" src="../../assets/RSsserviceManage/套件使用逻辑素材/公共内容/分屏联动锁开启.png">
      <img @click="toggleConnection" title="联动未开启" v-else src="../../assets/RSsserviceManage/套件使用逻辑素材/公共内容/分屏联动锁关闭.png">
    </div>

    <div v-if="showTools" :style="`position:absolute;right:0px;bottom: 0px;text-align:left;font-size:12px;width: ${showShootTime?'600px':'500px'};height:30px;line-height:30px;color: white;background-color: rgba(0,0,0,0.5);display: flex;`">
      <span style="margin-left: 20px;">审图号：GS吉(2023)011号</span>
      <span id="shootDate" v-show="showShootTime" style="margin-left: 20px;">拍摄时间：{{imagingTime}}</span>
      <!-- v-show="scaleShow" -->
      <div id="scaleBarDiv" data-tool-panel-title="比例尺" style="position: absolute;right: 153px;">
        <div id="scaleBar"></div>
      </div>
      <!-- class="map-decorate map-coordinate custom-mouse-position" v-show="coordinateShow"-->
      <div
        id="mouse-position"
        data-tool-panel-title="坐标"
        style="position:absolute;right: 23px;"
      ></div>
    </div>
</div>
</template>

<script>
import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
  import Map from 'ol/Map'
  import View from 'ol/View'
  import { XYZ, OSM, Vector, ImageArcGISRest,TileArcGISRest, TileWMS, Cluster,ImageWMS,VectorTile } from 'ol/source'
  import { Tile, Group, Image, Vector as lVector, VectorTile as lVectorTile  } from 'ol/layer'
  import Feature from 'ol/Feature.js';
  import TileGrid from 'ol/tilegrid/TileGrid'
  import { createXYZ } from 'ol/tilegrid'
  import { Style, Fill, Stroke, Circle, Text, Circle as CircleStyle,Icon } from 'ol/style'
  import { unByKey } from 'ol/Observable'
  import Overlay from 'ol/Overlay'
  import { GeoJSON, WFS, WMSCapabilities,WMTSCapabilities,WMSGetFeatureInfo,MVT } from 'ol/format'
  import { equalTo,bbox } from 'ol/format/filter'
  import { getArea, getLength } from 'ol/sphere'
  import { Polygon, LineString, MultiPolygon,Point } from 'ol/geom'
  import { Draw, Select, Modify as iModify, DragBox, DoubleClickZoom } from 'ol/interaction'
  import { ScaleLine, MousePosition, defaults,Zoom } from 'ol/control'
  import { createStringXY,format as formatCoordinate } from 'ol/coordinate'
  import { fromLonLat,toLonLat,get as projGet } from 'ol/proj'
  import Legend from 'ol-ext/control/Legend'
  // import LayerSwitcher from 'ol-ext/control/LayerSwitcher'
  import ol_ext_element from 'ol-ext/util/element'
  // import { httpAction } from '../../api/manage'
  import { platformModifierKeyOnly, singleClick } from 'ol/events/condition'
  import PopupFeature from 'ol-ext/overlay/PopupFeature'
  import Popup from 'ol-ext/overlay/Popup'
  import { createEmpty, extend, getWidth, getHeight,getCenter } from 'ol/extent'
  import Overview from 'ol-ext/control/Overview'
  import LayerSwitcherImage from 'ol-ext/control/LayerSwitcherImage'
  import Swipe from 'ol-ext/control/Swipe'
  import MapboxVectorLayer from 'ol/layer/MapboxVector';
  import SearchBar from './utils/SearchBar.vue'
  import coordtransform from 'coordtransform'
  import turf from "turf";
  import WKT from "terraformer-wkt-parser"
  import SearchUploadFiles from './SearchVector/SearchUploadFiles'
  import { GeometryToMulti, MultiToGeometry } from './utils/polygonHelp'
export default {
    components: {},
    props: {
      lyrdata: {
        type: Array,
        default: () => ([])
      },
      mapCtrlTools: {
        type: Array,
        default: () => ([])
      },
      mapServiceDist: {
        type: String,
        default: () => ('')
      },
      mapParams: {
        type: Object,
        default: () => ({})
      },
      taskStatus: {
        type: Array,
        default: () => ([])
      },
      fullScreen:{
        type: Boolean,
        default: false
      },
      showTools: {
        type: Boolean,
        default: true
      },
      showSearchBar: {
        type: Boolean,
        default: true
      }
    },
  data() {
    return {
        /**地图左上角-功能启动图标按钮-初始化控制**/
        lyrsBtnShow: false, //图层管理控制-功能启动图标按钮，默认false不显示
        measureBtnShow: false, //测量工具-功能菜单启动图标按钮，默认false不显示
        decorateBtnShow: false, //地图整饰-功能菜单启动图标按钮，默认false不显示
        juanlianShow: false, //卷帘-功能菜单启动图标按钮，默认false不显示
        dataPanel: false, //打开/关闭数据面板-功能菜单启动图标按钮，默认false不显示
        legendBtnShow: false, //地图图例-功能菜单启动图标按钮，默认false不显示
        lyrPanal: false, //首页复选框-功能菜单启动图标按钮，默认false不显示
        blingblingBtn: false, //首页触发闪烁的按钮-功能菜单启动图标按钮，默认false不显示
        legendPanelVisible: false, //显示图例面板
        toolBoxPanelVisible: false, //工具箱下拉显示标识，默认是关闭状态
        measurePanelVisible: false, //量测下拉框显示标识，默认是关闭状态
        isMeasure: false, 
        POLYGON: '', //新绘制的图斑点坐标数组
        coordinateShow: true, //显示坐标
        scaleShow: true, //显示比例尺
        // baseMap: [], //每个页面在myConf.js中配置的底图layers，在数据展示页面中使用
        checkedMapKey:[],//勾选的图层的key,在数据展示页面中使用
        mapLayersToShow: [], //从数据库中查询到的已发布到每个页面的显示图层后续合并到图层数组中 by qhy
        map: {},
        allHide: true,
        isEdit: false, //记录“业务数据管理”面板中的编辑按钮是否已点击
        defaultStylesForOwnShipData: [], //初始化读过来的权属数据的样式
        // fullScreen:false,//全屏
        cluResolution:this.GLOBAL.CLUSTER.RESOLUTION,//用于配置矢量图层和集群的临界点的分辨率
        cluDistance:this.GLOBAL.CLUSTER.DISTANCE,//集群的参数distance

        juanlianPanelVisible:true,  //默认true为隐藏
        flagJL:true,//卷帘控制切换开关标志
        swipe:{},//卷帘control
        notJLLayers:[],//保存此时不卷帘且visible为true的图层数组
        JLLeftlyr:{},//新卷帘左图层
        JLRightlyr:{},//新卷帘右图层
        // JLlyrs:[],//新卷帘左右图层
        url: {
          list: "/business/business/list",
        },
        // mapMarks: this.GLOBAL.mapMarks,
        featureTypesForAttr:[],//属性
        switcher:{},//图层面板控件

        departname:[],//部门名分成的区名和部门名，用于根据所属区和部门显示图斑

        cqlFromTab:'',//成果统计中各个tab传过来的cql
        cqlInterval:null,//切换cql时创建的定时器

        // black_waterUrl:`http://202.111.178.10:34573/geoserver/black_water/wms?service=WMS&version=1.1.0&request=GetMap&layers=black_water:black_water_business&styles=`,

        //
        black_waterPointUrl:`http://121.36.101.27:8000/geoserver/blackwater/wms?service=WMS&version=1.1.0&request=GetMap&layers=blackwater:business&styles=`,

        cqlUrl:'',//如果卫星纠错被勾选，则url为luotuweixingshenhe的，否则为luotu的
        // cqlUrl1:'',//如果卫星纠错被勾选，则url为luotuweixingshenhe的，否则为luotu的
        checkedNames:[],//保存首页左下角被勾选的名字
        cqlsForBling:[],//第一个只有静止的组合的cql，第二个是全都有的cql
        cqlFromPage:'',//各个页面对应的cql

        nameDetail:'',//双击后保存的行政区名称
        pageHref:window.location.href,
        location: {},//定位跳转功能的Vector
        locationStyle: new Style({//定位点的样式
            image: new Icon({
                anchor: [0.5, 0],//设置图标偏移
                anchorOrigin: 'bottom-left',//标注样式的起点位置
                anchorXUnits: 'fraction', //X方向单位：分数
                anchorYUnits: 'pixels',//Y方向单位：像素
                // offsetOrigin: 'top-right',//偏移起点位置的方向
                opacity: 0.9,//透明度
                src: 'https://sj3upload.obs.cn-north-4.myhuaweicloud.com/imgs/%E5%AE%9A%E4%BD%8D%E8%B7%B3%E8%BD%AC.png',//图片路径
                scale: 0.2
            }),
        }),
        zoomLevel: '4',
        labelShow: true, 

        drawFinished:false,//是否绘制完成
        source: null,//勾绘和量测的图层source
        vector: null,//勾绘和量测的图层vector
        curMk:'',
        curTk: '',

        
        drawSelected:'绘制多边形',
        drawBtnShow:false,
        isUploadVector: false,
        
        isSelectRegion: false,
        chinaProvinceNow: '',
        chinaCityNow: '',
        chinaCountyNow: '',
        chinaProvinceItems:[],
        chinaCityItems:[],
        chinaCountyItems:[],
        countryNow: '',
        countryItems: [],

        makeVectorName:false,   
        createSearchName: '',   
        uploadAndSelectVector: '',   


        //提示相关参数
        snackbar:false,
        snackbarColor:"",
        snackbarInfo:"",
        timeout: 3000,


        overlay: false,

        showShootTime: false,//显示拍摄时间
        imagingTime: '',//拍摄时间

        
        viewArr:[],
        mapArr: [],
        isConnection:true,
    }
  },
  created() {

  },
  mounted() {
      this.loadGisMap();

  },
  methods: {
    async loadGisMap() {
        let that = this
        let lyrdata = this.lyrdata
        
        let mapCenter=this.mapParams.center;
        mapCenter=fromLonLat(mapCenter);

        //region View和Map
        var viewAll = new View({
          projection: this.mapParams.projection, //例如：'EPSG:4326', //发布的影像原始坐标系为4326，必须加上此投影才能显示发布的影像
          center: mapCenter, //例如：[127.87535, 43.58279] 或 [126.47535, 43.58279],//地图初始中心点
          minZoom: this.mapParams.minZoom, //例如：5，//可以缩小的最小级别;若为undefined表示无限制
          maxZoom: this.mapParams.maxZoom, //例如：19，//可以放大的最大级别；若为undefined表示无限制
          zoom: this.mapParams.zoom, //例如：6，//地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
        //   constrainResolution:true,
        //   smoothResolutionConstraint:false,
        })

        for (let i = 0; i < 4; i++) {
            let view = new View({
                projection: this.mapParams.projection, //例如：'EPSG:4326', //发布的影像原始坐标系为4326，必须加上此投影才能显示发布的影像
                center: mapCenter, //例如：[127.87535, 43.58279] 或 [126.47535, 43.58279],//地图初始中心点
                minZoom: this.mapParams.minZoom, //例如：5，//可以缩小的最小级别;若为undefined表示无限制
                maxZoom: this.mapParams.maxZoom, //例如：19，//可以放大的最大级别；若为undefined表示无限制
                zoom: this.mapParams.zoom, //例如：6，//地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
                constrainResolution:true,
                smoothResolutionConstraint:false,
            })
            this.viewArr.push(view)
            let map = new Map({
                controls: defaults({ zoom: false,rotate:false }), //默认不显示缩放控件
                // controls: defaults({ rotate:false }), //默认不显示缩放控件
                target: `map${i+1}`, //地图容器div的ID
                layers: [], //例如：tiandituLayersGroup,osmLayer,vector1
                // view: this.viewArr[i]
                view:this.viewArr[0]
            })
            this.mapArr.push(map)
            var tiandituSatelliteLabel = new Tile({
              title: '天地图注记',
              source: new XYZ({
                url: 'http://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d',
                crossOrigin: 'anonymous',
                maxZoom: 18,
                minZoom: 0,
              }),
              visible: true,
              zIndex: 1
            })
            map.addLayer(tiandituSatelliteLabel)
          }
        console.log('this.viewArr',this.viewArr)
        console.log('this.mapArr',this.mapArr)

        // this.map = this.mapArr[0];

        //region 比例尺、坐标控件
        //比例尺控件
        var scaleLineControl = new ScaleLine({
          units: 'metric',
          target: 'scaleBar',
          className: 'ol-scale-line'
        })

        //坐标
        var mousePositionControl = new MousePosition({
          // coordinateFormat: createStringXY(5), //坐标小数位数
          coordinateFormat: (coordinate) => {
            // 显示gcj02火星坐标系
            let gcj02Coordinate=coordtransform.wgs84togcj02(coordinate[0],coordinate[1])
            return formatCoordinate(gcj02Coordinate, '{x}, {y}', 2);
          },
          className: 'custom-mouse-position',
          target: document.getElementById('mouse-position'),
          undefinedHTML: '&nbsp;',
          projection:'EPSG:4326'
        })

        if (this.showTools) {
          //将比例尺控件添加到地图容器中
          this.mapArr[3].addControl(scaleLineControl)
          //将坐标控件添加到地图容器中
          this.mapArr[3].addControl(mousePositionControl)
        }
        //endregion
        
        //region 循环调用addLyr4init()方法把lyrdata解析出来（保留图层组合结构）
        lyrdata = [...lyrdata, ...this.mapLayersToShow] //除了myconf.js配置的图层外加入发布的图层
        console.log('lyrdata',lyrdata)
        // this.baseMap = []
        for (let i = 0, len = lyrdata.length; i < len; i++) {
            for (let j = 0; j < 4; j++) {
                let tmpLyrs = await addLyr4init(
                  lyrdata[i].lyrType,
                  lyrdata[i].srcType,
                  lyrdata[i].mUrl,
                  lyrdata[i].mTitle,
                  lyrdata[i].mName,
                  lyrdata[i].mVisible,
                  lyrdata[i].mExtent,
                  lyrdata[i].mSubLayers,
                  lyrdata[i].mKey
                )
                tmpLyrs.forEach(value => {
                    this.mapArr[j].addLayer(value)
                })
            }
        }
        this.zoomLevel=this.mapArr[0].getView().getZoom()
        
        //endregion

        //region 【方法】初始化添加图层
        async function addLyr4init(lyrType, srcType, mUrl, mTitle, mName, mVisible, mExtent, mSubLayers,mKey) {
          //以下部分用于设置集群的样式及半径大小的计算
          let maxFeatureCount
          let calculateClusterInfo = function(resolution) {
            maxFeatureCount = 0
            let features = lyr.getSource().getFeatures()
            let feature, radius
            for (let i = features.length - 1; i >= 0; --i) {
              feature = features[i]
              let originalFeatures = feature.get('features')
              let extent = createEmpty()
              let j = void 0,
                jj = void 0
              for (j = 0, jj = originalFeatures.length; j < jj; ++j) {
                extend(extent, originalFeatures[j].getGeometry().getExtent())
              }
              maxFeatureCount = Math.max(maxFeatureCount, jj)
              /* radius = 0.025 * (getWidth(extent) + getHeight(extent)) /
                  resolution; */
              feature.set('radius', 1)
            }
          }

          let currentResolution
          function styleFunction(feature, resolution) {
            if (resolution != currentResolution) {
              calculateClusterInfo(resolution)
              currentResolution = resolution
            }
            let style
            if (feature.get('features')) {
              let size = feature.get('features').length
              if (size >= 1) {
                style = new Style({
                  image: new CircleStyle({
                    radius: feature.get('radius'),
                    fill: new Fill({
                      color: [255, 153, 0, Math.min(0.8, 0.4 + size / maxFeatureCount)]
                    })
                  }),
                  text: new Text({
                    text: size.toString(),
                    fill: new Fill({
                      color: '#fff'
                    }),
                    stroke: new Stroke({
                      color: 'rgba(0, 0, 0, 0.6)',
                      width: 3
                    }),
                    font: '20px sans-serif'
                  })
                })
              } else {
                // var originalFeature = feature.get('features')[0];
                // style = createEarthquakeStyle(originalFeature);
                style = null //没啥用
              }
            }
            return style
          }
          //以上部分用于设置集群的样式及半径大小的计算
          // function vectorStyle(feature, resolution) {
          //   let style = new Style({
          //     fill: new Fill({
          //       color: 'rgba(255, 255, 255, 0)' //填充颜色
          //     }),
          //     stroke: new Stroke({
          //       color: 'red', //边框颜色
          //       width: 2 // 边框宽度
          //     }),
          //   })

          //   return style
          // }

          function vectorLoader(extent, resolution, projection) {
            let this1=this;
            var proj = projection.getCode()
            var url = mUrl
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url)
            var onError = function() {
              this1.removeLoadedExtent(extent)
            }
            xhr.onerror = onError
            xhr.onload = function() {
              if (xhr.status == 200) {
                let features = this1.getFormat().readFeatures(xhr.responseText)
                if (that.taskStatus.length!=0) {//这种方式不好，应该直接从服务中过滤，待改！
                  features=features.filter(feature=>{
                    if (that.taskStatus.includes(feature.values_.status)) {
                      return true;
                    }
                    return false;
                  })
                }
                // features=features.filter(feature=>{
                //   if (this1.url_===feature.values_.time) {
                //     return true;
                //   }
                //   return false;
                // })
                this1.addFeatures(features)
              } else {
                onError()
              }
            }
            xhr.send()
          }



          //以下部分用于获取服务中的extent属性以及图例，不同服务有不同的获取方式，需要详细考虑
          let ext=[];
          let layersForLegend=[];
          let resolutions=[];
          let times=new Set();
          if (/geoserver/.test(mUrl)) {
            let parser = new WMSCapabilities();
            // let parser = new WMSGetFeatureInfo();
            let name='';
            // let tempURL = mUrl+'&request=GetCapabilities';
            let tURL = mUrl;
            let tempURL = mUrl;
            if (/GetFeature/i.test(tURL)) {//暂时没解决
              // tURL=tURL.replace(/GetFeature/,'GetCapabilities');
              tURL.split("?")[1].split("&").forEach(value=>{
                if (/(LAYERS|typeName)=.+?/.test(value)) {
                  name= value;
                }
              })
              name=name.split("=")[1];
              // that.featureTypesForAttr.push(name);
              // if (name) {
              //   await that.$axios({url: tURL}).then(function(response) {
              //     let result = parser.read(response.data);
              //     console.log(response.data)
              //     console.log(result);
              //     result.FeatureTypeList.FeatureType.forEach(layer=>{
              //       if (layer.Title===name) {
              //         ext=[layer.LatLongBoundingBox.minx,layer.LatLongBoundingBox.miny,layer.LatLongBoundingBox.maxx,layer.LatLongBoundingBox.maxy];
              //         console.log(ext);
              //       }
              //     })
              //     Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
              //   })
              //   .catch(function(error) {
              //     console.log(error)
              //   })
              // }

              await that.$axios({url: tURL}).then(function(response) {
                let features = new GeoJSON().readFeatures(response.data)
                features.forEach(f=>{
                  times.add(f.values_.time);
                })
                times=Array.from(times).sort();//排序
                // times=Array.from(times);
                Promise.resolve();//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
              }).catch(function(error) {
                  console.log(error)
                })
            }else if (/GetMap/i.test(tURL)) {
              tURL=tURL.replace(/GetMap/,'GetCapabilities');
              tURL.split("?")[1].split("&").forEach(value=>{
                if (/(LAYERS|typeName)=.+?/i.test(value)) {
                  name= value;
                }
              })
              name=name.split("=")[1];
              that.featureTypesForAttr.push(name);
              name=name.split(":")[1];
              if (name) {
                let stylesForLegend=[];
                await that.$axios({url: tURL}).then(function(response) {
                  let result = parser.read(response.data);
                  // console.log(result);
                  result.Capability.Layer.Layer.forEach(layer=>{
                    if (layer.Name===name) {
                      ext=layer.EX_GeographicBoundingBox;//可能为undefined
                      if (!ext) {
                        ext=layer.BoundingBox[0].extent;
                      }
                      // layer.Style.forEach(style=>{
                      //   let legendURLs=style.LegendURL;
                      //   legendURLs.forEach(leg=>{
                      //     layersForLegend.push(leg);
                      //   })
                      // })
                    }
                  })
                  Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
                  .catch(function(error) {
                    console.log(error)
                  })
              }
            }else if (/tms/i.test(tURL)) {
              let layerName=tURL.split('/');
              layerName=layerName[layerName.length-1].split('@')[0];
              let ws=layerName.split('%')[0];
              let getCapabilitiesUrl=`${tURL.split('gwc')[0]+ws}/wms?service=WMS&version=1.1.0&request=GetCapabilities&layers=${layerName}&styles=`;

              name=layerName;
              // that.featureTypesForAttr.push(name);
              name=name.split("%3A")[1];
              if (name) {
                let stylesForLegend=[];
                await that.$axios({url: getCapabilitiesUrl}).then(function(response) {
                  let result = parser.read(response.data);
                  // console.log(result);
                  result.Capability.Layer.Layer.forEach(layer=>{
                    if (layer.Name===name) {
                      ext=layer.EX_GeographicBoundingBox;//可能为undefined
                      if (!ext) {
                        if (Math.abs(layer.BoundingBox[0].extent[0]-124)<100) {//待改
                          ext=layer.BoundingBox[0].extent;
                        }
                      }
                      if (layer.Name!='JiLinShp') {
                        layer.Style.forEach(style=>{
                          let legendURLs=style.LegendURL;
                          legendURLs.forEach(leg=>{
                            layersForLegend.push(leg);
                          })
                        })
                      }
                    }
                  })
                  Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
                .catch(function(error) {
                  console.log(error)
                })
              }
              let parserForTMS=new DOMParser(); //解析xml或者html
              await that.$axios({url: tURL}).then(function(response) {
                let xmlDoc=parserForTMS.parseFromString(response.data,"text/xml"); //解析xml或者html
                //提取数据
                let box = xmlDoc.getElementsByTagName('BoundingBox');
                let attr=box[0].attributes;
                ext=[Number(attr[0].value),Number(attr[1].value),Number(attr[2].value),Number(attr[3].value)];
                // console.log(ext);
                let tileSets = xmlDoc.getElementsByTagName('TileSets')[0].children;
                for (const t of tileSets) {
                  resolutions.push(t.attributes['units-per-pixel'].nodeValue);
                }
              })
              .catch(function(error) {
                console.log(error)
              })
            }else{
              tempURL+='&request=GetCapabilities';
              tempURL.split("?")[1].split("&").forEach(value=>{
                if (/(LAYERS|typeName)=.+?/i.test(value)) {
                  name= value;
                }
              })
              name=name.split(":")[1];
              // let reg=/(LAYERS|typeName)=.+?&/.exec(tempURL);//?非贪婪模式匹配最少字符
              // console.log(reg);
              if (name) {
                let stylesForLegend=[];
                await that.$axios({url: tempURL}).then(function(response) {
                  let result = parser.read(response.data);
                  // console.log(result);
                  result.Capability.Layer.Layer.forEach(layer=>{
                    if (layer.Name===name) {
                      ext=layer.EX_GeographicBoundingBox;//可能为undefined
                      if (!ext) {
                        ext=layer.BoundingBox[0].extent;
                      }
                      layer.Style.forEach(style=>{
                        let legendURLs=style.LegendURL;
                        legendURLs.forEach(leg=>{
                          layersForLegend.push(leg);
                        })
                      })
                    }
                  })
                  Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
                  .catch(function(error) {
                    console.log(error)
                  })
              }
            }
          }else if (/arcgis/.test(mUrl)) {
            let tempURL = mUrl+'?f=json';
            await that.$axios({url: tempURL}).then(function(response) {
              let fExt=response.data.fullExtent;
              ext=[fExt.xmin,fExt.ymin,fExt.xmax,fExt.ymax]
              Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
            })
              .catch(function(error) {
                console.log(error)
              })

            tempURL = mUrl+'/legend?f=json';
            await that.$axios({url: tempURL}).then(function(response) {
              // console.log(response.data)
              layersForLegend=response.data;
              Promise.resolve();//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
            })
              .catch(function(error) {
                console.log(error)
              })
          }
          //以上部分用于获取服务中的extent属性以及图例，不同服务有不同的获取方式，需要详细考虑

          let lyrArr = []
          let lyr = null
          if (lyrType === 'Image' && srcType === 'TileWMS') {
            lyr = new Image({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              source: new TileWMS({
                url: mUrl,
                params:{
                  BBOX:ext
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Image' && srcType === 'ImageArcGISRest') {
            lyr = new Image({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              layersForLegend:layersForLegend,
              source: new ImageArcGISRest({
                url: mUrl,
                params:{
                  BBOX:ext
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Image' && srcType === 'ImageWMS') {
            let cql=null;
            // debugger
            if (that.departname.length==1&&/解译/.test(mTitle)) {
              let keyName='';
              if (/^市/.test(that.departname[0])||!/[区市山县]/.test(that.departname[0])) keyName='depart';
              else keyName='cou';
              cql=`${keyName} like '%${that.departname[0]}%'`;
            }
            if (that.departname.length==2&&/解译/.test(mTitle)) {
              cql=`cou like '%${that.departname[0]}%'&&depart like '%${that.departname[1]}%'`;
            }

            if (/解译/.test(mTitle)&&that.cqlFromPage!=''&&that.cqlFromPage!=null) {//加上各页面的查询条件
              if (cql==null) cql=that.cqlFromPage;
              else cql+=` and ${that.cqlFromPage}`
            }

            lyr = new Image({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              layersForLegend:layersForLegend,
              source: new ImageWMS({
                crossOrigin:'anonymous',
                url: mUrl,
                params:{
                  BBOX:ext,
                  'CQL_FILTER':cql
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Tile' && srcType === 'TileArcGISRest') {
            lyr = new Tile({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              layersForLegend:layersForLegend,
              source: new TileArcGISRest({
                url: mUrl,
                params:{
                  BBOX:ext
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Tile' && srcType === 'TileWMS') {
            lyr = new Tile({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              layersForLegend:layersForLegend,
              source: new TileWMS({
                url: mUrl,
                params:{
                  BBOX:ext
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Tile' && srcType === 'XYZ') {
            let display=true;
            if (mTitle==="公主岭市底图") {
              display=false;
            }
            if(mTitle==="路网"||mTitle==="卫星"||mTitle==="文字标注"){
              lyr = new Tile({
                title: mTitle,
                name: mName,
                visible: mVisible,
                key:mKey,
                displayInLayerSwitcher: display, //在图层面板中不显示
                source: new XYZ({
                  url: mUrl,
                  params:{
                    BBOX:ext
                  }
                })
              })
            }else{
              let source={};
              if (/(charmingglobe)|(tile)|(getMap)/.test(mUrl)) {//一室那边给的url（需要提前将数字改成/{z}/{x}/{-y}）
                source = new XYZ({
                  // crossOrigin:'anonymous',
                  projection: 'EPSG:3857',
                  maxZoom: 18,
                  minZoom: 0,
                  url:mUrl,
                })
              }else{
                source = new XYZ({
                  // crossOrigin:'anonymous',
                  projection: 'EPSG:4326',//这里是影像的投影
                  // projection: that.mapParams.projection,
                  maxZoom: 18,
                  minZoom: 0,
                  tileGrid: new TileGrid({
                    extent: ext,
                    origin: [-180,-90],//必须是这个，否则对应不上
                    resolutions: resolutions,
                  }),
                  tileUrlFunction: function(tileCoord){
                    let z = tileCoord[0];
                    let x = tileCoord[1];
                    let y = tileCoord[2];
                    return `${mUrl}/${z}/${x}/${y}.png`
                  },
                  // url:mUrl,
                })
              }
              lyr = new Tile({
                title: mTitle,
                name: mName,
                visible: mVisible,
                key:mKey,
                source:source,
                layersForLegend:layersForLegend,
                displayInLayerSwitcher: display, //在图层面板中不显示
                BBOX:ext
              })
            }

            lyrArr.push(lyr)
          } else if (lyrType === 'lVector' && srcType === 'Vector') {
            //console.log("此为lVector-Vector类型");

            // let tempMarks={};
            // let per= 100/(times.length-1);
            // for (let i = 0; i < times.length; i++) {
            //   const element = i*per;
            //   tempMarks[element]=times[i];
            // }
            // that.marks=tempMarks;
            // times.forEach(time=>{

              lyr = new lVector({
                // title: time,
                // name: time,
                title: mTitle,
                name: mName,
                visible: mVisible,
                key:mKey,
                source: new Vector({
                  format: new GeoJSON(),
                  projection: 'EPSG:4326',
                  // url: time,//这里因为改成别的不能传参，所以暂时用这个，待改!
                  // loader:vectorLoader
                }),
                // style: that.styles[mTitle]
                style:new Style({stroke: new Stroke({color: 'rgba(0, 255, 255, 1)',width: 2})})
              })
              lyrArr.push(lyr);

              // let geom = JSON.parse(mUrl)
              // let feature=new Feature({
              //   geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
              // })
              // feature.getGeometry().transform('EPSG:4326', that.mapParams.projection)
              // lyr.getSource().addFeature(feature)
              // lyrArr.push(lyr);
              
              // // let ext=this.changeBboxFromLonLat(lyrdata[1].mExtent)
              // let ext = lyr.getSource().getExtent()
              // map.getView().fit(ext)//先这么跳着，有矢量就跳矢量
            // })
          } else if (lyrType === 'lVector' && srcType === 'Cluster') {
            //console.log("此为lVector-Cluster类型");
            let vectorSource = new Vector({
              format: new GeoJSON(),
              projection: 'EPSG:4490',
              loader: vectorLoader,
            })
            let tempResolution = that.cluResolution;
            let tempDistance = that.cluDistance;
            lyr = new lVector({
              title: mTitle,
              name: mName,
              visible: mVisible,
              //extent:mExtent, //左下点-右上点
              minResolution: tempResolution,
              key:mKey,
              source: new Cluster({
                distance: tempDistance,
                source: vectorSource,
                params:{
                  BBOX:ext
                },
                geometryFunction: function(feature) {
                  //获取多边形内点的方法
                  let geom = feature.getGeometry()
                  if (geom instanceof Polygon) {
                    return feature.getGeometry().getInteriorPoint()
                  } else if (geom instanceof MultiPolygon) {
                    return feature
                      .getGeometry()
                      .getInteriorPoints()
                      .getPoint(0)
                  }
                }
              }),
              style: styleFunction
            })
            lyrArr.push(lyr)

            let lyr1 = new lVector({
              title: mTitle,
              name: mName,
              visible: mVisible,
              displayInLayerSwitcher: false, //在图层面板中不显示
              maxResolution: tempResolution,
              key:mKey,
              source: new Vector({
                format: new GeoJSON(),
                projection: 'EPSG:4490',
                // url: mUrl,
                params:{
                  BBOX:ext
                },
                loader: vectorLoader
              })
            })
            lyrArr.push(lyr1)
          } else if (lyrType === 'Tile' && srcType === 'OSM') {
            lyr = new Tile({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              source: new OSM()
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'MapboxVectorLayer' && srcType === 'MapboxVectorLayer') {//矢量切片
            let country =new MapboxVectorLayer({
              styleUrl:require('./fontStyles/countryStyle.json')
            });
            let city =new MapboxVectorLayer({
              styleUrl:require('./fontStyles/cityStyle.json')
            });
            let road =new MapboxVectorLayer({
              styleUrl:require('./fontStyles/roadStyle.json')
            });
            let line =new MapboxVectorLayer({
              styleUrl:require('./fontStyles/lineStyle.json')
            });
            lyrArr.push(country,city,road ,line)
          }else if (lyrType === 'Group') {
            let lG = []
            for (let i = 0; i < mSubLayers.length; i++) {
              let lyr4tmps = null
              lyr4tmps =await addLyr4init(
                mSubLayers[i].lyrType,
                mSubLayers[i].srcType,
                mSubLayers[i].mUrl,
                mSubLayers[i].mTitle,
                mSubLayers[i].mName,
                mSubLayers[i].mVisible,
                mSubLayers[i].mExtent,
                mSubLayers[i].mSubLayers,
                mSubLayers[i].mKey,
              )
              lyr4tmps.forEach(value => {
                lG.push(value)
              })
            }
            lyr = new Group({
              title: mTitle,
              visible: mVisible,
              layers: lG
            })
            lyrArr.push(lyr)
          } else {
            console.log('抱歉，地图资源类型不明，请检查并重试，或联系管理员协助解决。')
          }
          return lyrArr
        }
        //endregion


        //region 定义“测量”和“勾绘”过程中用到的临时工作矢量层
        /*说明：这里只定义先不加载，等下面点击量测菜单或勾绘按钮后才加载*/
        that.source = new Vector() //图层数据源
        that.vector = new lVector({
          //title: '量测Measurement', //在图层面板中显示
          title: '临时工作图层（绘制图形用）', //在图层面板中显示
          source: that.source,
          //displayInLayerSwitcher:false,//设为false可以让此图层不显示在图层管理面板中
          style: new Style({
            //图层样式
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0)' //填充颜色
            }),
            stroke: new Stroke({
              color: '#ffcc33', //边框颜色
              width: 2 // 边框宽度
            }),
            image: new Circle({
              radius: 7,
              fill: new Fill({
                color: '#ffcc33'
              })
            })
          })
        })
        //endregion


        bus.$emit('loadGisMapRunOver')
    },
    fenpingChangeLayer(fenpingName) {
      this.mapArr.forEach((m,index) => {
        let allLayers = m.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        allLayers.forEach(layer => { 
          if (layer.values_.title!='天地图注记') {
            if (fenpingName[index] == layer.values_.title) {
              layer.setVisible(true)
            } else if (layer instanceof Tile &&layer.values_.title!='2024年度全国高质量一张图') {
              layer.setVisible(false)
            } else if (layer instanceof Vector && layer.values_.title == '边框') {
              layer.setVisible(true)
            }
          }
        })
      })
    },
    toggleConnection() {
      this.isConnection = !this.isConnection
      if (this.isConnection) {
        this.mapArr.forEach(m => {
          m.setView(this.viewArr[0])
        })
      } else {
        let center = this.mapArr[0].getView().getCenter()
        let zoom = this.mapArr[0].getView().getZoom()
        // debugger
        this.mapArr.forEach((m, index) => {
          m.setView(this.viewArr[index])
          m.getView().setCenter(center)
          m.getView().setZoom(zoom)
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fenping{
    position: absolute;
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: 50vw 50vw;
    grid-template-rows: 50vh 50vh;
    .map{
      border-right: 5px solid black;
      border-bottom: 5px solid black;
    }
}
.connectionBtn{
  cursor: pointer;
  position: absolute;
  transform: translate(calc(50vw - 25px),calc(50vh - 25px));
}
</style>